import React from 'react'
import QRCodeSVG from 'qrcode-svg'

export default function QRCode() {
  const __html = (
		new QRCodeSVG({
      content: `${window.location.origin}`,
      padding: 0,
      width: 256,
      height: 256,
      color: `currentColor`,
      background: `none`,
      container: `none`,
      join: true,
      ecl: `L`
    }).svg()
	)

  return (
    <svg
			viewBox="0 0 256 256"
			dangerouslySetInnerHTML={{
				__html
			}}
		/>
  )
}
